module.exports = __webpack_public_path__ + "static/img/bf-dia-star.ffe93d2d.png";